import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'dostawa',
    [ORDER_METHODS.PICKUP]: 'odbiór',
    [ORDER_METHODS.ROOM_SERVICE]: 'na miejscu',
  },
  feedback: {
    payment_method_disabled: 'Nie akceptujemy płatności {{paymentMethod}} dla zamówień {{orderMethod}}',
    cash_disabled: 'Nie akceptujemy płatności gotówkowych dla zamówień {{orderMethod}}',
  },
};
